const checkForUniqueErrors = (errField?: Array<string | Record<string, string>> | string) => {
    if (Array.isArray(errField)) {
        return errField.some((err) => !!err && typeof err === 'object' && 'rule' in err && err.rule === 'unique');
    }

    return false;
};

export default checkForUniqueErrors;
